var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36937 11.2271C8.73698 8.86973 12.3103 7.30335 14.1046 6.54343C19.2115 4.38772 20.285 4.01551 20.9751 4C21.1285 4 21.4659 4.03102 21.6959 4.21712C21.8799 4.37221 21.926 4.57382 21.9566 4.72891C21.9873 4.884 22.018 5.20968 21.9873 5.45782C21.7112 8.40447 20.515 15.554 19.9016 18.8418C19.6409 20.2376 19.1348 20.7029 18.644 20.7494C17.5705 20.8424 16.7577 20.036 15.7302 19.3536C14.1046 18.2835 13.1998 17.6166 11.6201 16.562C9.79516 15.3524 10.976 14.6855 12.0189 13.5999C12.2949 13.3207 17.0031 8.97829 17.0951 8.59057C17.1104 8.54405 17.1104 8.35794 17.0031 8.26489C16.8957 8.17184 16.7424 8.20286 16.6197 8.23387C16.451 8.26489 13.8745 10.0019 8.85967 13.4293C8.12354 13.9411 7.46409 14.1892 6.86598 14.1737C6.20654 14.1582 4.94898 13.8015 3.99815 13.4913C2.84795 13.1191 1.92779 12.9175 2.00447 12.2661C2.05048 11.9249 2.51056 11.5838 3.36937 11.2271Z",
    fill: "#92929E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramTask);
export default __webpack_public_path__ + "static/media/telegram-task.762685f56f8e33c7f7ef7fa33dd44787.svg";
export { ForwardRef as ReactComponent };